import { render, staticRenderFns } from "./H5Chat.vue?vue&type=template&id=0b91cde8&scoped=true"
import script from "./H5Chat.vue?vue&type=script&lang=js"
export * from "./H5Chat.vue?vue&type=script&lang=js"
import style0 from "./H5Chat.vue?vue&type=style&index=0&id=0b91cde8&prod&scoped=true&lang=scss"
import style1 from "./H5Chat.vue?vue&type=style&index=1&id=0b91cde8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b91cde8",
  null
  
)

export default component.exports